import { render } from "./MessageBoxV3.vue?vue&type=template&id=66e577dc&scoped=true"
import script from "./MessageBoxV3.vue?vue&type=script&lang=js"
export * from "./MessageBoxV3.vue?vue&type=script&lang=js"

import "./MessageBoxV3.vue?vue&type=style&index=0&id=66e577dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e577dc"]])

export default __exports__